import { gql } from '@apollo/client';

export const CREATE_CONTACT = gql`
  mutation CreateContact(
    $email: String!
    $name: String!
    $phone: String!
    $subject: String!
    $message: String!
  ) {
    createContactAndSendEmail(
      name: $name
      email: $email
      phone: $phone
      message: $message
      subject: $subject
    ) {
      email
    }
  }
`;
